import { HeroPage } from "@funcional/react-ui";
import { SsoRole, useJwtUser, SsoRolesEnum } from "@funcional/react-auth-ui";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";

const quickLinks = [
  {
    label: "Programas de PBM",
    path: "/pbm/programs",
    roles: [
      SsoRolesEnum.INDUSTRY,
      SsoRolesEnum.MASTER,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.RETAIL_PHARMA_BENEFIT_MANAGER,
    ],
  },
  {
    label: "Single Sign On",
    path: "/sso",
    roles: [SsoRolesEnum.MASTER],
  },
  {
    label: "Benefícios",
    path: "/benefits/multi",
    roles: [],
  },
  {
    label: "Reposição",
    path: "/refund/fixed-discount-rule",
    roles: [
      SsoRolesEnum.INDUSTRY,
      SsoRolesEnum.MASTER,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
      SsoRolesEnum.SUPPORT,
    ],
  },
];

export default function HomePage() {
  const { user } = useJwtUser();

  let firstName = (user?.name || "").split(" ")[0];
  if (firstName) {
    firstName = firstName[0].toUpperCase() + firstName.toLowerCase().slice(1);
  }

  const allowedQuicklinks = quickLinks
    .map((route) =>
      user && (route.roles.length == 0 || user.hasAnyOfTheseSsoRoles(...(route.roles as SsoRole[])))
        ? route
        : null
    )
    .filter(Boolean);

  const hasAccess = allowedQuicklinks.length > 0;

  return (
    <>
      <HeroPage title={firstName ? `Olá, ${firstName}!` : "Olá!"}>
        Este é o console de gerenciamento da Funcional, onde você encontra tudo
        o que precisa para acessar e gerenciar os programas de descontos e
        ferramentas da Funcional, em uma única interface web.
      </HeroPage>

      {hasAccess ? (
        <>
          <h3 className="mt-16 text-2xl font-bold tracking-tight text-center text-gray-500">
            Acesso Rápido:
          </h3>

          <div className="flex flex-wrap justify-center max-w-xl mx-auto mt-8">
            {allowedQuicklinks.map((route, key) => (
              <div className="w-1/2 p-4" key={key}>
                <Link
                  title={route?.label}
                  className="block"
                  to={{ pathname: route?.path }}
                >
                  <div className="px-4 py-3 font-medium text-center text-gray-900 bg-white border rounded-md shadow-sm cursor-pointer focus:border-brand hover:bg-gray-50 focus:outline-none sm:py-6">
                    <div className="block max-w-full font-semibold uppercase truncate">
                      {route?.label}
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <h3 className="mt-16 text-2xl font-bold tracking-tight text-center text-red-300">
            😕
            <br />
            Infelizmente você ainda não tem acesso a este portal.
            <br />
            Por favor, solicite acesso e tente novamente.
          </h3>
          <Button
            color="primary"
            className="w-full text-center"
            onClick={() => {
              window.location.href =
                (process.env.REACT_APP_SSO_URL || "sso.funcionalmais.com.br") +
                "/logout";
            }}
          >
            Entrar com outro usuário
          </Button>
        </>
      )}
    </>
  );
}
